<template>
  <div class="fin-screener-filter-step">
    <div class="select-header" v-if="selectTitle">
      {{ selectTitle }}
    </div>
    <v-select :item-color="$finColors.primaryDark"
              :items="items"
              :multiple="multiSelect"
              append-icon="icon-arrow-down"
              background-color="white"
              hide-details
              :item-text="itemText"
              :item-value="itemValue"
              :menu-props="{bottom: true, offsetY: true}"
              outlined
              :return-object="returnObject"
              :label="label"
              v-model="model"
              @change="handleOnSelectChange"
              ref="selectedEl"
    />
  </div>
</template>

<script>
export default {
  name: 'fin-screener-filter-step',
  props: {
    selectTitle: {
      type: String
    },
    items: {
      type: Array
    },
    keyVal: {
      type: String
    },
    value: {
      type: String
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    itemValue: {
      type: String
    },
    itemText: {
      type: String
    },
    label: {
      type: String
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    resetAfterChange: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    handleOnSelectChange() {
      if (this.resetAfterChange) {
        this.$refs["selectedEl"].reset()
        // remove focus to display the label
        this.$refs["selectedEl"].blur()
      }
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.select-header {
  padding-bottom: 10px;
  font-size: 1.4em;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
}
</style>
